import './FAQ.scss'
import content from './content.json'

export const FAQ = () => {
    return (
        <section id={"faq"}>
            <div>
                <h2 className={'faq-header'}>{content?.title}</h2>
                <p className={'faq-text'}>
                    {content?.description}<br/>{content?.contactText}
                    <a href={'mailto:contact@uxray.app'}>{content?.contactLinkText}</a>.
                </p>
            </div>
            <div className={'questions'}>
                {content.faqs && content.faqs.map((faq, index) => (
                    <details key={'question' + index}>
                        <summary>
                            <h3 className={'summary-header'}>{faq?.question}</h3>
                            <span aria-hidden="true" className="material-symbols-outlined">add</span>
                        </summary>
                        <p className={'answer-text'}>
                            {faq?.answer}
                        </p>
                    </details>
                ))}
            </div>
        </section>
    )
}